// import React, { useState } from 'react';


// const Work = () => {
//   const [isOpen, setIsOpen] = useState(true);

//   const closeModal = () => {
//     setIsOpen(false);
//   };

//   return (
//     isOpen && (
//       <div className="modal-overlay">
//         <div className="modal-content">
//           <h2>How it works?</h2>
//           <p>
//             Pump prevents rugs by making sure that all created tokens are safe.
//             Each coin on pump is a fair-launch with no presale and no team
//             allocation.
//           </p>
//           <ol>
//           <li className='steps-class'><span className='steps'>Step 1:</span> Pick a coin that you like</li>
//             <li  className='steps-class'><span className='steps'>Step 2:</span> Buy the coin on the bonding curve</li>
//             <li  className='steps-class'><span className='steps'>Step 3:</span> Sell at any time to lock in your profits or losses</li>
//             <li  className='steps-class'>
//             <span className='steps'>Step 4:</span> When enough people buy on the bonding curve it reaches a
//               market cap of $100k
//             </li>
//             <li className='steps-class'>
//             <span className='steps'>Step 5:</span> $17k of liquidity is then deposited in raydium and burned
//             </li>
//           </ol>
//           <button className="close-modal" onClick={closeModal}>
//             I&apos;m Ready to Pump
//           </button>
//         </div>
//       </div>
//     )
//   );
// };

// export default Work;
import React, { useState } from 'react';


const Work = () => {
  const [isOpen, setIsOpen] = useState(true);

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    isOpen && (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className='modal-cont'>
          <button className="close-but" onClick={closeModal}>
            ×
          </button>
          </div>
          <h2>How it works?</h2>
          <p>
            Pump prevents rugs by making sure that all created tokens are safe.
            Each coin on pump is a fair-launch with no presale and no team
            allocation.
          </p>
          <ol>
            <li className="steps-class">
              <span className="steps">Step 1:</span> Pick a coin that you like
            </li>
            <li className="steps-class">
              <span className="steps">Step 2:</span> Buy the coin on the bonding curve
            </li>
            <li className="steps-class">
              <span className="steps">Step 3:</span> Sell at any time to lock in your profits or losses
            </li>
            <li className="steps-class">
              <span className="steps">Step 4:</span> When enough people buy on the bonding curve, it reaches a
              market cap of $100k
            </li>
            <li className="steps-class">
              <span className="steps">Step 5:</span> $17k of liquidity is then deposited in raydium and burned
            </li>
          </ol>
          <button className="ready-button" onClick={closeModal}>
            I&apos;m Ready to Pump
          </button>
        </div>
      </div>
    )
  );
};

export default Work;
